import React from 'react';
import 'twin.macro';
import { FaceFrownIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import Button from 'components/Buttons/Button';
import { useNavigate } from 'react-router-dom';
import { useBillingInfosData } from 'queries/useBillingInfos';
import { useUserAccount } from 'queries/user/account/useUserAccount';
import { trackEvent } from 'queries/user/track';

export function NoMoreCredits() {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  const billingInfos = useBillingInfosData();
  const { data: userAccount } = useUserAccount();

  const shouldShowUpgrade =
    billingInfos?.plan !== 'integral' || userAccount?.isOnOldPricing;

  function handleMouseDown(e: React.MouseEvent) {
    e.preventDefault();
  }

  return (
    <div
      onMouseDown={handleMouseDown}
      tw="bg-white rounded-lg p-4 flex flex-col gap-2.5 w-[300px]"
    >
      <div tw="flex gap-1 items-start">
        <FaceFrownIcon tw="w-5 h-5 text-neutral-intense shrink-0" />
        <p tw="font-semibold text-neutral-intense">{t('ai.noCreditsTitle')}</p>
      </div>
      {shouldShowUpgrade && (
        <Button
          intent="primary"
          onClick={() => {
            trackEvent('Editor:AI:NoCredits:UpgradeToPricing');
            navigate('/pricing');
          }}
          tw="w-full"
        >
          {t('buttons.upgradeTo', { planLabel: 'Integral' })}
        </Button>
      )}
      <Button
        intent={shouldShowUpgrade ? 'none' : 'primary'}
        onClick={() => {
          trackEvent('Editor:AI:NoCredits:BuyCredits');
          navigate('/settings/usage?showPurchase=true');
        }}
        tw="w-full"
      >
        {t('ai.buyCredits')}
      </Button>
    </div>
  );
}
